import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const icon = css`
  width: 22px;
  height: 22px;
  border: 4px solid ${colors.white};
  background: ${colors.white};
  box-shadow: 0px 1px 10px ${colors.shadows.getShadow(colors.black, 0.3)};
  box-sizing: content-box;
  border-radius: 50%;
  cursor: pointer;
`;

export const endCarIcon = css`
  cursor: pointer;
`;
